export default class ExternalSignIn {
	constructor({ elements }) {
		elements.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				this.handleSignIn(el);
			});
		});
	}

	handleSignIn(el) {
		const formId = el.getAttribute('data-sign-in-form');
		if (!formId) return;

		const form = document.getElementById(formId);
		if (form) {
			form.submit();
		}
	}
}
